<div class="modal-header justify-content-start px-4 pt-4 pb-3">
    <div class="row w-100">
        <div class="col-11 p-0">
            <div class="modal-main-heading">Schedule Your Calls With Us</div>
        </div>
        <div class="col-1">
            <button type="button" class="close" (click)="onCloseClick()">
                <span class="black-text cursor--pointer">×</span>
            </button>
        </div>
    </div>
</div>

<div class="modal-body">
    <div class="d-block mb-4">
        <span class="d-flex body-1 mb-2">Choose Event Type</span>
        <ul class="list--schedule body-2">
            <li [ngClass]="{'selected': selectedItem === 1}" (click)="selectItem(1)">In-Person</li>
            <li [ngClass]="{'selected': selectedItem === 2}" (click)="selectItem(2)">Hybrid</li>
            <li [ngClass]="{'selected': selectedItem === 3}" (click)="selectItem(3)">Virtual</li>
        </ul>
    </div>
    <span class="d-flex body-1 mb-2">Recommended Actions and Calls</span>

    <ng-container *ngIf = "eventType === 'in-person'">
        <div class="d-block pb-3">
            <div class="card mb-3">
                <div class="card-body card-body--schedule" (click)="openLink('https://calendly.com/d/cbwr-cbv7/paybee-onboarding')">
                    <div class="row">
                        <div class="col-9 d-flex flex-column justify-content-between w-100">
                            <div class="d-flex body-2--weight-medium">Onboarding/Planning Call</div>
                            <div class="d-flex caption grey-text">We will help you set up your ticketing and registration and all other fundraising campaigns, event and event page in preparation for your event</div>
                            <div class="before-event-text--schedule">4-6 weeks or ealier</div>
                        </div>
                        <div class="col-3 d-flex">
                            <div class="d-flex ml-auto align-items-center">
                                <div class="before-event-text--schedule blue-text"><i class="fas fa-calendar mr-1"></i> Schedule</div>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>
            <div class="card mb-3">
                <div class="card-body card-body--schedule" (click)="openLink('https://paybee.io/@paybee@43')">
                    <div class="row">
                        <div class="col-9 d-flex flex-column justify-content-between w-100">
                            <div class="d-flex body-2--weight-medium">Order Card Readers</div>
                            <div class="d-flex caption grey-text">For faster checkout, order bluetooth card readers. We can ship it to you and you will return after the event.</div>
                            <div class="before-event-text--schedule">2-3 weeks before event</div>
                        </div>
                        <div class="col-3 d-flex">
                            <div class="d-flex ml-auto align-items-center">
                                <div class="before-event-text--schedule blue-text"><i class="fas fa-credit-card mr-1"></i> Order</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card mb-3">
                <div class="card-body card-body--schedule" (click)="openLink('https://calendly.com/d/cgt-nxb-s9z/paybee-onboarding-pt-2')">
                    <div class="row">
                        <div class="col-9 d-flex flex-column justify-content-between w-100">
                            <div class="d-flex body-2--weight-medium">Pre-Event Check In Call</div>
                            <div class="d-flex caption grey-text">We can help you with managing your guest list, send out reminders and assign paddles and tables.</div>
                            <div class="before-event-text--schedule">1 week before event</div>
                        </div>
                        <div class="col-3 d-flex">
                            <div class="d-flex ml-auto align-items-center">
                                <div class="before-event-text--schedule blue-text"><i class="fas fa-calendar mr-1"></i>Schedule</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card mb-3">
                <div class="card-body card-body--schedule" (click)="openLink('https://calendly.com/d/nwdr-z7c6/volunteer-training')">
                    <div class="row">
                        <div class="col-9 d-flex flex-column justify-content-between w-100">
                            <div class="d-flex body-2--weight-medium">Volunteer Training Call</div>
                            <div class="d-flex caption grey-text">We will train your Volunteers and staff to use the PayBee app for all event day activities like checkin, add pledges checkout etc.</div>
                            <div class="before-event-text--schedule">2-3 days before event</div>
                        </div>
                        <div class="col-3 d-flex">
                            <div class="d-flex ml-auto align-items-center">                                
                                <div class="d-flex ml-auto align-items-center">
                                    <div class="before-event-text--schedule blue-text"><i class="fas fa-calendar mr-1"></i> Schedule</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    
        </div>
    </ng-container>

    <ng-container *ngIf = "eventType === 'hybrid'">
        <div class="d-block pb-3">
            <div class="card mb-3">
                <div class="card-body card-body--schedule" (click)="openLink('https://calendly.com/c/CBAU7QHXMWHTUNV4')">
                    <div class="row">
                        <div class="col-9 d-flex flex-column justify-content-between w-100">
                            <div class="d-flex body-2--weight-medium">Onboarding Call</div>
                            <div class="d-flex caption grey-text">We will help you set up your ticketing and registration and all other fundraising campaigns, event and event page in preparation for your event</div>
                            <div class="before-event-text--schedule">4-6 weeks before event</div>
                        </div>
                        <div class="col-3 d-flex">
                            <div class="d-flex ml-auto align-items-center">                                
                                <div class="d-flex ml-auto align-items-center">
                                    <div class="before-event-text--schedule blue-text"><i class="fas fa-calendar mr-1"></i> Schedule</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card mb-3">
                <div class="card-body card-body--schedule" (click)="openLink('https://calendly.com/d/wcrh-bwt4/hybrid-production-call')">
                    <div class="row">
                        <div class="col-9 d-flex flex-column justify-content-between w-100">
                            <div class="d-flex body-2--weight-medium">Production Call</div>
                            <div class="d-flex caption grey-text">Run through steps to manage the PayBee backend, live-stream and virtual and in-person attendee experiences</div>
                            <div class="before-event-text--schedule">1-2 weeks before event</div>
                        </div>
                        <div class="col-3 d-flex">
                            <div class="d-flex ml-auto align-items-center">                                
                                <div class="d-flex ml-auto align-items-center">
                                    <div class="before-event-text--schedule blue-text"><i class="fas fa-calendar mr-1"></i>Schedule</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card mb-3">
                <div class="card-body card-body--schedule" (click)="openLink('https://paybee.io/@paybee@43')">
                    <div class="row">
                        <div class="col-9 d-flex flex-column justify-content-between w-100">
                            <div class="d-flex body-2--weight-medium">Order Card Readers</div>
                            <div class="d-flex caption grey-text">For faster checkout, order bluetooth card readers. We can ship it to you and you will return after the event.</div>
                            <div class="before-event-text--schedule">2 weeks before event</div>
                        </div>
                        <div class="col-3 d-flex">
                            <div class="d-flex ml-auto align-items-center">                                
                                <div class="d-flex ml-auto align-items-center">
                                    <div class="before-event-text--schedule blue-text"><i class="fas fa-credit-card mr-1"></i> Order</div>                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card mb-3">
                <div class="card-body card-body--schedule" (click)="openLink('https://calendly.com/d/cgt-nxb-s9z/paybee-onboarding-pt-2')">
                    <div class="row">
                        <div class="col-9 d-flex flex-column justify-content-between w-100">
                            <div class="d-flex body-2--weight-medium">Pre-Event Check In Call</div>
                            <div class="d-flex caption grey-text">Edit your guest list, send out reminders and assign paddles and tables</div>
                            <div class="before-event-text--schedule">1 week before event</div>
                        </div>
                        <div class="col-3 d-flex">
                            <div class="d-flex ml-auto align-items-center">                                
                                <div class="d-flex ml-auto align-items-center">
                                    <div class="before-event-text--schedule blue-text"><i class="fas fa-calendar mr-1"></i>Schedule</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card mb-3">
                <div class="card-body card-body--schedule" (click)="openLink('https://calendly.com/d/96gm-h6f/dry-run-with-paybee')">
                    <div class="row">
                        <div class="col-9 d-flex flex-column justify-content-between w-100">
                            <div class="d-flex body-2--weight-medium">Rehearsal Call With Auctioneer</div>
                            <div class="d-flex caption grey-text">Conduct a dry run with your PayBee backend team, clerk, auctioneer and PayBee rep</div>
                            <div class="before-event-text--schedule">3-5 days before event</div>
                        </div>
                        <div class="col-3 d-flex">
                            <div class="d-flex ml-auto align-items-center">                                
                                <div class="d-flex ml-auto align-items-center">
                                    <div class="before-event-text--schedule blue-text"><i class="fas fa-calendar mr-1"></i>Schedule</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card mb-3">
                <div class="card-body card-body--schedule" (click)="openLink('https://calendly.com/d/nwdr-z7c6/volunteer-training')">
                    <div class="row">
                        <div class="col-9 d-flex flex-column justify-content-between w-100">
                            <div class="d-flex body-2--weight-medium">Volunteer Training Call</div>
                            <div class="d-flex caption grey-text">Train vour Volunteers to use the PavBee app for all event dav activities</div>
                            <div class="before-event-text--schedule">2-3 days before event</div>
                        </div>
                        <div class="col-3 d-flex">
                            <div class="d-flex ml-auto align-items-center">                                
                                <div class="d-flex ml-auto align-items-center">
                                    <div class="before-event-text--schedule blue-text"><i class="fas fa-calendar mr-1"></i>Schedule</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>

    <ng-container *ngIf = "eventType === 'virtual'">
        <div class="d-block pb-3">
            <div class="card mb-3">
                <div class="card-body card-body--schedule" (click)="openLink('https://calendly.com/c/CBAU7QHXMWHTUNV4')">
                    <div class="row">
                        <div class="col-9 d-flex flex-column justify-content-between w-100">
                            <div class="d-flex body-2--weight-medium">Onboarding Call</div>
                            <div class="d-flex caption grey-text">Set up your ticketing and all other fundraising campaigns, event and event page in preparation for your event</div>
                            <div class="before-event-text--schedule">4-6 weeks before event</div>
                        </div>
                        <div class="col-3 d-flex">
                            <div class="d-flex ml-auto align-items-center">                                
                                <div class="d-flex ml-auto align-items-center">
                                    <div class="before-event-text--schedule blue-text"><i class="fas fa-calendar mr-1"></i>Schedule</div>
                                </div>
                            </div>
                        </div>
                    </div>                    
                </div>
            </div>
            <div class="card mb-3">
                <div class="card-body card-body--schedule" (click)="openLink('https://calendly.com/d/nw6j-rmzn/paybee-production-call')">
                    <div class="row">
                        <div class="col-9 d-flex flex-column justify-content-between w-100">
                            <div class="d-flex body-2--weight-medium">Production Call</div>
                            <div class="d-flex caption grey-text">Run through steps to manage the PayBee backend, live-stream and virtual and in-person attendee experiences</div>
                            <div class="before-event-text--schedule">4 weeks before event</div>
                        </div>
                        <div class="col-3 d-flex">
                            <div class="d-flex ml-auto align-items-center">                                
                                <div class="d-flex ml-auto align-items-center">
                                    <div class="before-event-text--schedule blue-text"><i class="fas fa-calendar mr-1"></i>Schedule</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card mb-3">
                <div class="card-body card-body--schedule" (click)="openLink('https://calendly.com/d/96gm-h6f/dry-run-with-paybee')">
                    <div class="row">
                        <div class="col-9 d-flex flex-column justify-content-between w-100">
                            <div class="d-flex body-2--weight-medium">Rehearsal Call With Auctioneer</div>
                            <div class="d-flex caption grey-text">Conduct a dry run with your PayBee backend team, clerk, auctioneer and PayBee rep</div>
                            <div class="before-event-text--schedule">3-5 days before event</div>
                        </div>
                        <div class="col-3 d-flex">
                            <div class="d-flex ml-auto align-items-center">
                                <div class="d-flex ml-auto align-items-center">
                                    <div class="before-event-text--schedule blue-text"><i class="fas fa-calendar mr-1"></i>Schedule</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>
</div>


